import { render, staticRenderFns } from "./PageBackoffice.vue?vue&type=template&id=31d65240&scoped=true"
import script from "./PageBackoffice.vue?vue&type=script&lang=js"
export * from "./PageBackoffice.vue?vue&type=script&lang=js"
import style0 from "./PageBackoffice.vue?vue&type=style&index=0&id=31d65240&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d65240",
  null
  
)

export default component.exports